import React from 'react';

import { useFilterAttributes } from '../../filterAttributesContext';

import { DesktopFilters } from './DesktopFilters/DesktopFilters';
import { FiltersSkeleton } from './FiltersSkeleton';

const Filters = () => {
  const { attributes, isLoading } = useFilterAttributes();

  if (isLoading) return <FiltersSkeleton />;
  if (!attributes) return null;

  return <DesktopFilters />;
  // TODO: use this once we have a need for mobile filters and maybe look for PR with ticket ID GUEX-236
  // return widgetArea.isLarge ? <DesktopFilters /> : <MobileFilters />
};

export default Filters;
